"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecipientToken = function (trunkrsNr, postalCode) {
    var normalizedPostalCode = postalCode.replace(/\s/g, '').toUpperCase();
    return "TrackAndTalk " + trunkrsNr + " " + normalizedPostalCode;
};
